import styled from '@emotion/styled';
import Text from '@molecules/Text';
import BEIcon from '@molecules/BEIcon';
import { useMemo } from 'react';
import { BEIconNameType } from '@molecules/BEIcon/BEIconProps';
import { faIcons } from '@molecules/BEIcon/icons';
import { AmenityKeys } from './icons.types';

const StyledAmenity = styled.div`
	flex-basis: 24%;
	display: flex;
  align-items: center;
	padding: 8px 0;
	gap: 8px;
`;

type AmenityProps = {
  name: string;
  slug?: AmenityKeys;
};

const Amenity = ({ name, slug }: AmenityProps) => {
  const iconName = useMemo(() => {
    if (!slug) return;
    if (slug in faIcons) {
      return slug as BEIconNameType;
    }
  }, [name, slug]);

  return (
    <StyledAmenity>
      {iconName && <BEIcon size="lg" name={iconName} weight="regular"></BEIcon>}
      {!iconName && <BEIcon size="lg" name="check" weight="regular"></BEIcon>}
      <Text type="h4" weight="400">
        {name}
      </Text>
    </StyledAmenity>
  );
};

export default Amenity;
